import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { PaginationModule } from './pagination/pagination.module';

import { PLATFORM_ID, APP_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header.component';
import { SearchComponent } from './search.component';
import { SearchPageComponent } from './search-page.component';
import { CitySelectComponent } from './city-select.component';
import { HeaderBasketComponent } from './header-basket.component';
import { TopNavComponent } from './top-nav.component';
import { HeaderProfileComponent } from './header-profile.component';
import { LeftMenuComponent } from './left-menu.component';
import { ShopSliderComponent } from './shop-slider.component';
import { FilterComponent } from './filter.component';
import { FilterSliderComponent } from './filter-slider.component';
import { ConsultComponent } from './consult.component';
import { PageNotFoundComponent } from './page-not-found.component';
import { SignInComponent } from './signin.component';
import { SignUpComponent } from './signup.component';
import { SocialsComponent } from './socials.component';
import { SocialComponent } from './social.component';
import { HashtagsComponent } from './hashtags.component';
import { HashtagPipe } from './hashtag.pipe';
import { FooterComponent } from './footer.component';
import { HomePageComponent } from './home-page.component';
import { CatalogItemsComponent } from './catalog-items.component';
import { CatalogFilterComponent } from './catalog-filter.component';
import { PromoSliderComponent } from './promo-slider.component';
import { PersonalOrdersComponent } from './personal-orders.component';
import { RoutesModule } from './routes.module';
import { ScrollHeaderDirective } from './scrollheader.directive';
import { ConsultService } from './consult.service';
import { FilterService } from './filter.service';
import { UserService } from './user.service';
import { CookieModule } from 'ngx-cookie';
import { CatalogService } from './catalog/catalog.service';
import { CatalogFilterService } from './catalog-filter.service';
import { CatalogSectionService } from './catalog-section.service';
import { PromoService } from './promo.service';
import { NotificationService } from './notification.service';
import { CartService } from './cart/cart.service';
import { OrderService } from './cart/order.service';
import { CompareService } from './compare/compare.service';
import { BreadCrumbsService } from './breadcrumbs.service';
import { UserGuardService } from './user.service';
import { SearchService } from './search.service';
import { CityService } from './city.service';
import {SearchWithBasketComponent} from './search-with-basket.component';
import {RegionsPageComponent} from './regions-page/regions-page.component';

const imports: any[] = [
  CommonModule,
  BrowserModule.withServerTransition({ appId: 'shop-static' }),
  FormsModule,
  HttpClientModule,
  HttpClientJsonpModule,
  RoutesModule,
  PaginationModule,
  CookieModule.forRoot(),
];

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SearchComponent,
    SearchWithBasketComponent,
    SearchPageComponent,
    CitySelectComponent,
    HeaderBasketComponent,
    TopNavComponent,
    HeaderProfileComponent,
    LeftMenuComponent,
    ShopSliderComponent,
    FilterComponent,
    FilterSliderComponent,
    ConsultComponent,
    PageNotFoundComponent,
    SignInComponent,
    SignUpComponent,
    SocialsComponent,
    SocialComponent,
    HashtagsComponent,
    FooterComponent,
    HomePageComponent,
    CatalogItemsComponent,
    CatalogFilterComponent,
    PromoSliderComponent,
    PersonalOrdersComponent,
    ScrollHeaderDirective,
    HashtagPipe,
    RegionsPageComponent
  ],
  imports: imports,
  providers: [
    {provide: LOCALE_ID, useValue: 'ru'},
    ConsultService,
    FilterService,
    SearchService,
    UserService,
    CatalogSectionService,
    CatalogService,
    CatalogFilterService,
    PromoService,
    NotificationService,
    CartService,
    OrderService,
    CompareService,
    BreadCrumbsService,
    UserGuardService,
    CityService,
  ],
  bootstrap: [
    AppComponent,
  ]
})
export class AppModule {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(APP_ID) private appId: string) {
    const platform = isPlatformBrowser(platformId) ?
      'in the browser' : 'on the server';
    console.log(`Running ${platform} with appId=${appId}`);
  }
}
